var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { attrs: { reverse: _vm.$wf.isLgUp } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("general")))]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("repeat-bank-save"),
                                    },
                                    model: {
                                      value: _vm.generalSettings.RepeatBankSave,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalSettings,
                                          "RepeatBankSave",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalSettings.RepeatBankSave",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      label: _vm.$ct("show-sales-in-bank-edit"),
                                    },
                                    model: {
                                      value: _vm.generalSettings.RepeatBankSave,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalSettings,
                                          "RepeatBankSave",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalSettings.RepeatBankSave",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-select-bank-type", {
                                    attrs: {
                                      "use-ids": "",
                                      fancy: "",
                                      label: _vm.$ct(
                                        "default-convert-to-credit-note-bank"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.generalDossierSettings
                                          .DefaultConvertSaleToCreditNoteBankTypeID,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalDossierSettings,
                                          "DefaultConvertSaleToCreditNoteBankTypeID",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalDossierSettings.DefaultConvertSaleToCreditNoteBankTypeID",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-select-bank-type", {
                                    attrs: {
                                      "use-ids": "",
                                      fancy: "",
                                      label: _vm.$ct(
                                        "default-payment-difference-bank"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.generalDossierSettings
                                          .DefaultPaymentDifferenceBankTypeID,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalDossierSettings,
                                          "DefaultPaymentDifferenceBankTypeID",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalDossierSettings.DefaultPaymentDifferenceBankTypeID",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-select-bank-type", {
                                    attrs: {
                                      "use-ids": "",
                                      fancy: "",
                                      label: _vm.$ct("cash-payment-bank"),
                                    },
                                    model: {
                                      value:
                                        _vm.generalDossierSettings
                                          .DefaultCashPaymentBankTypeID,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalDossierSettings,
                                          "DefaultCashPaymentBankTypeID",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalDossierSettings.DefaultCashPaymentBankTypeID",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-select-bank-type", {
                                    attrs: {
                                      "use-ids": "",
                                      fancy: "",
                                      label: _vm.$ct("sepa-payment-bank"),
                                    },
                                    model: {
                                      value:
                                        _vm.generalDossierSettings
                                          .DefaultSepaPaymentBankTypeID,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalDossierSettings,
                                          "DefaultSepaPaymentBankTypeID",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalDossierSettings.DefaultSepaPaymentBankTypeID",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      items: _vm.sepaPainVersionItems,
                                      fancy: "",
                                      label: _vm.$ct("sepa-pain-version"),
                                    },
                                    model: {
                                      value:
                                        _vm.generalDossierSettings
                                          .SepaPainVersion,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalDossierSettings,
                                          "SepaPainVersion",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalDossierSettings.SepaPainVersion",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "cash-payment-difference-ledger-number"
                                      ),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.generalDossierSettings
                                          .DefaultCashRoundingLedgerAccountCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalDossierSettings,
                                          "DefaultCashRoundingLedgerAccountCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "generalDossierSettings.DefaultCashRoundingLedgerAccountCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-sale-type-multi-select", {
                                    attrs: {
                                      "use-id": "",
                                      fancy: "",
                                      "contact-group-id": 1,
                                      disabled:
                                        !_vm.canEditSaleTypesForBookings,
                                      label: _vm.$ct("sale-types-for-bookings"),
                                    },
                                    model: {
                                      value:
                                        _vm.bankConfig.SaleTypeIDsForBookings,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.bankConfig,
                                          "SaleTypeIDsForBookings",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "bankConfig.SaleTypeIDsForBookings",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.saveGeneral()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("common.save")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("app-mollie-settings"),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("bank-types"))),
                      ]),
                      _c(
                        "w-sortable",
                        {
                          attrs: {
                            tag: "w-list",
                            items: _vm.types,
                            "target-class": "handle",
                          },
                          on: {
                            drop: function ($event) {
                              return _vm.updateOrder()
                            },
                          },
                        },
                        [
                          _vm._l(_vm.types, function (item) {
                            return _c(
                              "w-list-item",
                              { key: item.ID, attrs: { "show-handle": "" } },
                              [
                                _c("w-list-item-text", [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(_vm._s(item.ID) + ": "),
                                    ]),
                                    _vm._v(" " + _vm._s(item.Name) + " "),
                                    _vm.isBankTypeDefault(item)
                                      ? _c("span", { staticClass: "default" }, [
                                          _vm._v(
                                            "(" +
                                              _vm._s(_vm.$ct("default")) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("set-as-default"),
                                            expression: "$ct('set-as-default')",
                                          },
                                        ],
                                        attrs: {
                                          disabled: _vm.isBankTypeDefault(item),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setAsDefault(item)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "cogs" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.edit"),
                                            expression: "$ct('common.edit')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editType(item)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.delete"),
                                            expression: "$ct('common.delete')",
                                          },
                                        ],
                                        staticClass: "danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteType(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "w-list-item",
                            {
                              attrs: { disabled: _vm.maxBankTypesReached },
                              on: {
                                click: function ($event) {
                                  return _vm.openNewModal()
                                },
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _c(
                                  "div",
                                  [
                                    _c("w-fa", { attrs: { icon: "plus" } }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("add-new")) + " "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c("app-bank-configure-terminal-bookings", {
                    staticClass: "mt",
                  }),
                  _c("app-bank-configure-ctep-terminal", {
                    staticClass: "mt",
                    attrs: { "bank-type": _vm.toEditType },
                  }),
                  _c("app-bank-configure-ctep-bank-type-per-brand-settings", {
                    staticClass: "mt",
                  }),
                  _c("app-bank-configure-mollie-terminal", {
                    staticClass: "mt",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditType != null } },
            [
              _vm.toEditType
                ? _c(
                    "w-card",
                    { attrs: { "max-width": "700" } },
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.modalTitle))]),
                      _c(
                        "w-scroll-view",
                        { attrs: { tag: "w-card-content" } },
                        [
                          _c("w-tabs", {
                            staticClass: "mb",
                            attrs: { tabs: _vm.modalTabs },
                            model: {
                              value: _vm.modalTab,
                              callback: function ($$v) {
                                _vm.modalTab = $$v
                              },
                              expression: "modalTab",
                            },
                          }),
                          _vm.modalTab == 0
                            ? _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("label-name"),
                                        },
                                        model: {
                                          value: _vm.toEditType.Name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "Name",
                                              $$v
                                            )
                                          },
                                          expression: "toEditType.Name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("label-ledger-number"),
                                        },
                                        model: {
                                          value: _vm.toEditType.LedgerNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "LedgerNumber",
                                              $$v
                                            )
                                          },
                                          expression: "toEditType.LedgerNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "label-account-number"
                                          ),
                                        },
                                        model: {
                                          value: _vm.toEditType.AccountNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "AccountNumber",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.AccountNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("label-iban"),
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.autoFillBic()
                                          },
                                        },
                                        model: {
                                          value: _vm.toEditType.Iban,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "Iban",
                                              $$v
                                            )
                                          },
                                          expression: "toEditType.Iban",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("label-bic"),
                                        },
                                        model: {
                                          value: _vm.toEditType.Bic,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.toEditType, "Bic", $$v)
                                          },
                                          expression: "toEditType.Bic",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "label-show-on-cashier"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.toEditType.ShowOnCashierDisplay,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "ShowOnCashierDisplay",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.ShowOnCashierDisplay",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "label-show-in-accounting"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.toEditType.ShowInAccounting,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "ShowInAccounting",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.ShowInAccounting",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("show-on-coda-import"),
                                        },
                                        model: {
                                          value:
                                            _vm.toEditType.ShowOnCodaImport,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "ShowOnCodaImport",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.ShowOnCodaImport",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          value:
                                            !_vm.toEditType.HideOnSaleLayout,
                                          fancy: "",
                                          label: _vm.$ct("show-on-sale-layout"),
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.toEditType.HideOnSaleLayout =
                                              !$event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    {
                                      staticClass: "with-hint",
                                      attrs: { xs: "12" },
                                    },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "create-counter-booking-on-dagontvangst"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.toEditType
                                              .CreateCounterBookingOnDagontvangst,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "CreateCounterBookingOnDagontvangst",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.CreateCounterBookingOnDagontvangst",
                                        },
                                      }),
                                      _c("app-hint", {
                                        attrs: {
                                          title: _vm.$ct(
                                            "create-counter-booking-on-dagontvangst"
                                          ),
                                          text: _vm.$ct(
                                            "create-counter-booking-on-dagontvangst-hint"
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "sepa-filename-format"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.toEditType.SepaFileNameFormat,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "SepaFileNameFormat",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.SepaFileNameFormat",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("app-payment-means-code-select", {
                                        attrs: {
                                          label: _vm.$ct(
                                            "ubl-payment-means-code"
                                          ),
                                          "empty-text": _vm.$ct(
                                            "ubl-payment-means-code-dossier-default"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.toEditType.UblPaymentMeansCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditType,
                                              "UblPaymentMeansCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "toEditType.UblPaymentMeansCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel",
                              attrs: { icon: "ban", disabled: _vm.isSaving },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              attrs: { icon: "save", disabled: _vm.isSaving },
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }